export default __webpack_public_path__ + "static/creativespace-ef058d0f5705dcdbfc29b3cfa628ea2a.jpg";